import { ExternalLink } from '@montel/montelpro-shared-components';
import {
	HStack,
	IconCheckCircle,
	Text,
	Tooltip,
} from '@montel/montelpro-shared-components-v2';
import styled from 'styled-components';

const StyledTooltip = styled(Tooltip)`
	margin-left: 0;
`;

export const HubSpotLabel: React.FunctionComponent<{
	hubSpotId: number | null;
	isPrimary: boolean;
}> = ({ hubSpotId, isPrimary }) => {
	const showTooltip = isPrimary && hubSpotId && hubSpotId > 0;
	return (
		<HStack align="center">
			{showTooltip && (
				<StyledTooltip
					contentSize="sm"
					component={
						<IconCheckCircle size="sm" color="iconSuccess" />
					}
				>
					This is a primary contact
				</StyledTooltip>
			)}
			<HubSpotText hubSpotId={hubSpotId} />
		</HStack>
	);
};

const HubSpotText: React.FunctionComponent<{
	hubSpotId: number | null;
}> = ({ hubSpotId }) => {
	if (hubSpotId === 0) {
		return (
			<Text size="xs" color="textSubtle">
				Hubspot contact was removed
			</Text>
		);
	}
	if (!hubSpotId) {
		return (
			<Text size="xs" color="textSubtle">
				Not connected to hubspot
			</Text>
		);
	}
	return (
		<ExternalLink
			href={`https://app.hubspot.com/contacts/${process.env.REACT_APP_HUBSPOT_ACCOUNT_ID}/contacts/${hubSpotId}`}
		>
			View in HubSpot
		</ExternalLink>
	);
};
